<template>
    <div class="search-result">
        <!-- ============= 顶部背景图 ============= -->
        <div class="result-img" style='background: url("web/bk/bk1.png");background-size: 100%;'>
            <table width="990" height="770" cellspacing="0" cellpadding="0" border="0" align="center">
  <tbody>
  
  <tr>
    <td valign="top" height="429" background="images/about_02.gif" align="center">
		<h1>&nbsp;</h1>
		<h1>SinoLink Plus + Keil C51仿真：</h1>
		<h2>
		<button type="button" onclick="window.open('https://www.bilibili.com/video/BV1a48se4EYQ/?spm_id_from=333.999.0.0')">前往B站观看</button>
		</h2>
        <iframe src="https://player.bilibili.com/player.html?bvid=BV1a48se4EYQ" allowfullscreen="true" scrolling="no" border="0" framespacing="0" width="640" height="480" frameborder="no"></iframe>
		<h1>&nbsp;</h1>
		<h1>&nbsp;</h1>
		<h1>SinoLink Plus + Keil MDK仿真：</h1>
		<h2>
		<button type="button" onclick="window.open('https://www.bilibili.com/video/BV1jJ8sewEwM/?spm_id_from=333.999.0.0')">前往B站观看</button>
		</h2>
        <iframe src="https://player.bilibili.com/player.html?bvid=BV1jJ8sewEwM" allowfullscreen="true" scrolling="no" border="0" framespacing="0" width="640" height="480" frameborder="no"></iframe>
		<h1>&nbsp;</h1>
		<h1>&nbsp;</h1>
		<h1>SinoLink Plus + ProWriter量产烧录：</h1>
		<h2>
		<button type="button" onclick="window.open('https://www.bilibili.com/video/BV1iJ8sewEs4/?spm_id_from=333.999.0.0')">前往B站观看</button>
		</h2>
        <iframe src="https://player.bilibili.com/player.html?bvid=BV1iJ8sewEs4" allowfullscreen="true" scrolling="no" border="0" framespacing="0" width="640" height="480" frameborder="no"></iframe>
		<h1>&nbsp;</h1>
		<h1>&nbsp;</h1>
	<h1>量产工具Pro06C 使用说明</h1>
		<h2>
		<button type="button" onclick="window.open('https://www.bilibili.com/video/BV1Vu4y117Lt/?spm_id_from=333.999.0.0')">前往B站观看</button>&nbsp;&nbsp;
		<button type="button" onclick="window.open('https://www.bilibili.com/video/BV1G48se4Ez2/?spm_id_from=333.999.0.0')">简易介绍</button>
		</h2>
        <iframe src="https://player.bilibili.com/player.html?bvid=BV1Vu4y117Lt" allowfullscreen="true" scrolling="no" border="0" framespacing="0" width="640" height="480" frameborder="no"></iframe>
		<h1>&nbsp;</h1>
		<h1>&nbsp;</h1>
	<h1>量产工具Pro03A使用说明</h1>
		<h2><button type="button" onclick="window.open('https://v.youku.com/v_show/id_XNDMzMjg4MjI3Ng==.html?spm=a2h0k.11417342.soresults.dtitle')">前往youku观看</button>&nbsp;&nbsp;
		<button type="button" onclick="window.open('https://www.bilibili.com/video/av65596468?from=search&amp;seid=1173273932979616461')">前往B站观看</button>
		</h2>
		<iframe src="https://player.bilibili.com/player.html?bvid=BV1i4411B7w6" allowfullscreen="true" scrolling="no" border="0" framespacing="0" width="640" height="480" frameborder="no"></iframe>
	<!--iframe src="http://player.youku.com/embed/XNDMzMjg4MjI3Ng==" allowfullscreen="true" scrolling="no" border="0" framespacing="0" width="640" height="480" frameborder="no"></iframe-->
   </td>
  </tr>
  
</tbody></table>
        </div>
    </div>
</template>

<script>
    import api from '@/http/request'
    export default {
        data() {
            return {
            }
        },
        mounted: function (){},
        methods: {
        },
    };
    
</script>



// WEBPACK FOOTER //
// src/pages/product/toolteach.vue